// Print the on-screen receipt through a hidden iframe (no pop-up window, so browsers don't block it).

const PRINT_CSS = `
  * { box-sizing: border-box; }
  body { margin: 0; padding: 24px; font-family: "Segoe UI", Arial, sans-serif; color: #111; background: #fff; }
  .dp-receipt { max-width: 420px; margin: 0 auto; }
  .rc-brand { display: flex; gap: 12px; align-items: center; margin-bottom: 18px; }
  .rc-mark { width: 42px; height: 42px; border-radius: 12px; display: grid; place-items: center; font-weight: 700; background: #4a1f5c; color: #f7d299; }
  .rc-brand h2 { margin: 0; font-size: 1.3rem; }
  .rc-brand p { margin: 2px 0 0; font-size: 12px; color: #444; }
  .rc-meta { display: grid; grid-template-columns: 1fr 1fr; gap: 8px 12px; margin-bottom: 16px; font-size: 12px; }
  .rc-meta span { display: block; color: #555; }
  table { width: 100%; border-collapse: collapse; font-size: 13px; }
  th, td { padding: 8px 0; border-bottom: 1px solid #e3e3e3; text-align: left; vertical-align: top; }
  th { font-size: 11px; text-transform: uppercase; letter-spacing: 0.04em; color: #555; }
  .num { text-align: right; white-space: nowrap; }
  .rc-sub { color: #555; font-size: 11px; margin-top: 2px; }
  tfoot td { border-bottom: none; color: #333; padding-top: 6px; }
  tfoot tr.rc-grand td { font-weight: 700; font-size: 15px; color: #111; border-top: 2px solid #111; padding-top: 10px; }
  .rc-foot { margin-top: 18px; font-size: 12px; color: #444; text-align: center; }
  @page { margin: 0; size: auto; }
  @media print { body { padding: 14mm; } }
`;

export default function printReceipt(elementId = 'dp-receipt') {
  const source = document.getElementById(elementId);
  if (!source) return false;
  document.getElementById('dp-print-frame')?.remove();
  const frame = document.createElement('iframe');
  frame.id = 'dp-print-frame';
  frame.setAttribute('aria-hidden', 'true');
  frame.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;opacity:0;pointer-events:none;';
  document.body.appendChild(frame);
  const doc = frame.contentDocument || frame.contentWindow?.document;
  if (!doc) return false;
  doc.open();
  doc.write(`<!DOCTYPE html><html><head><meta charset="utf-8"><title> </title><style>${PRINT_CSS}</style></head><body>${source.outerHTML}</body></html>`);
  doc.close();
  setTimeout(() => {
    frame.contentWindow?.focus();
    frame.contentWindow?.print();
  }, 150);
  return true;
}
